module.exports = __webpack_public_path__ + "img/journal-page-top.cffa05f5.png";